// extracted by mini-css-extract-plugin
module.exports = {"container":"MyPageModal_container__dFVUN","fullWidth":"MyPageModal_fullWidth__N3B2O","modalBody":"MyPageModal_modalBody__YLY0F"};